import { memoize } from 'lodash'
import { APIConfig, Id } from 'types/definitions'

import { BusinessProfileServicePromiseClient } from '@taxfyle/api-internal/internal/business_profile_grpc_web_pb'
import { enableDevTools } from 'utils/grpc-util'
import { createGrpcAuthenticator } from 'infra/grpc-authenticator'
import {
  GetBusinessProfileForJobRequest,
  GetBusinessProfileRequest,
} from '@taxfyle/api-internal/internal/business_profile_pb'

export function createBusinessProfilesAPI(config: APIConfig) {
  return new BusinessProfilesAPI(config)
}

export class BusinessProfilesAPI {
  private readonly businessProfilesClient = createBusinessProfilesClient(
    this.config.baseURL,
  )

  private readonly grpcAuthenticator = createGrpcAuthenticator(this.config)

  constructor(private config: APIConfig) {}

  /**
   * Gets business profile for a given job ID.
   */
  async getBusinessProfileForJob(jobId: Id) {
    const req = new GetBusinessProfileForJobRequest().setJobId(Id.assert(jobId))

    return this.businessProfilesClient
      .getBusinessProfileForJob(req, await this.grpcAuthenticator.getMeta())
      .then((res) => res.toObject())
  }

  /**
   * Gets business profile.
   */
  async getBusinessProfile(id: Id) {
    const req = new GetBusinessProfileRequest().setId(Id.assert(id))

    return this.businessProfilesClient
      .getBusinessProfile(req, await this.grpcAuthenticator.getMeta())
      .then((res) => res.toObject())
  }
}

/**
 * Creates a business profiles client that is memoized.
 */
const createBusinessProfilesClient = memoize(
  function createBusinessProfilesGrpcClient(baseUrl: string) {
    const client = new BusinessProfileServicePromiseClient(baseUrl)
    enableDevTools(client)
    return client
  },
)
